function searchPopup() {
    var $searchPopup = jQuery('.js-trigger-search');
    var $searchClose = jQuery('.js-close-search');
    var $searchModal = jQuery('.search-modal');
    $searchPopup.on('click', function(evt) {
        evt.preventDefault();
        $searchModal.toggleClass('search-modal__modal--opened');
        setTimeout(function() {
            jQuery('form input.js-search-input').focus();
        }, 100)
    });
    // Fermer la recherche

    $searchClose.on('click', function(evt) {
        $searchModal.removeClass('search-modal__modal--opened');
    });
}



jQuery(document).ready(function($) {
    searchPopup();
})